import Vue from 'vue'
import VueRouter from 'vue-router'
import mobileRoutes from '@/mobile/router'
import { generateCalcRoutes } from '@/calc-system/autoCalcRoutes'
import { CALC_REGISTRY } from '@/calc-system/registry/calc_registry'
import { initGlobalJsonLd, injectCalcJsonLd, clearPageJsonLd } from '@/utils/seo'

Vue.use(VueRouter)

// UA 检测：判断是否为移动设备
function isMobileDevice() {
	return /Android|iPhone|iPad|iPod|Mobile|MicroMessenger/i.test(navigator.userAgent)
}

const routes = [...mobileRoutes, {
	path: '/',
	name: 'HomePage',
	component: () => import( /* webpackChunkName: "about" */ '@/views/HomePage.vue'),
	children: [{
			path: '/',
			name: 'HomeIndex', //首页
			component: () => import( /* webpackChunkName: "about" */ '@/views/HomeIndex.vue'),
			meta: {
				keepAlive: false, // 标记列表页需要缓存
				title: '首页',
				description: '建数工厂 - 建筑工程专业工具平台。20+免费工程费用计算器（监理费/设计费/招标代理费），实时全国招标公告查询，建筑企业资质在线检索，广东、四川、山东、河北多省标准，建筑从业者首选工具。'
			}
		},
		{
			path: '/SelectQualification', //资质列表
			name: 'SelectQualification',
			component: () => import( /* webpackChunkName: "about" */ '@/views/SelectQualification.vue'),
			meta: {
				keepAlive: true,
				title: '企业资质查询',
				description: '免费查询全国建筑企业资质，输入企业名称秒查资质等级、证书编号、有效期及业绩，支持施工总承包、专业承包多类资质筛选，快速核实企业资质真伪。'
			}
		},
		{
			path: '/CompanyDetail', //资质详情，公司详情
			name: 'CompanyDetail',
			component: () => import( /* webpackChunkName: "about" */ '@/views/CompanyDetail.vue'),
			meta: {
				keepAlive: false,
				title: '企业详情',
				description: '查看建筑企业完整资质档案，资质等级、证书编号、有效期、注册资金、法定代表人一览无余，快速判断企业实力与投标资格。'
			}
		},
		{
			path: '/CompanyBidding', //招标列表
			name: 'CompanyBidding',
			component: () => import( /* webpackChunkName: "about" */ '@/views/CompanyBidding.vue'),
			meta: {
				keepAlive: true,
				title: '招标信息',
				description: '实时更新全国工程招标公告，每日新增数千条，支持按项目名称、招标类型、公告类型、项目地区精准筛选，第一时间掌握最新招标动态。'
			}
		},
		{
			path: '/BiddingDetail', //招标详情
			name: 'BiddingDetail',
			component: () => import( /* webpackChunkName: "about" */ '@/views/BiddingDetail.vue'),
			meta: {
				keepAlive: false,
				dynamicTitle: true,
				description: '查看招标公告完整内容，包括项目概况、招标方式、投标资质要求、报名截止时间及联系方式，助您快速判断是否符合投标条件。'
			}
		},
		{
			path: '/TenderList',
			name: 'TenderList',
			component: () => import( /* webpackChunkName: "about" */ '@/views/TenderList.vue'),
			meta: {
				keepAlive: false,
				title: '行业知识',
				description: '建筑行业专业知识库，涵盖资质政策解读、招投标实操指南、工程造价要点、最新法规标准，持续更新，助力建筑从业者提升专业竞争力。'
			}
		},
		{
			path: '/TenderDetail',
			name: 'TenderDetail',
			component: () => import( /* webpackChunkName: "about" */ '@/views/TenderDetail.vue'),
			meta: {
				keepAlive: false,
				dynamicTitle: true,
				description: '建筑行业专业知识深度解析，涵盖行业政策动态、资质标准变化及工程实操要点，助您紧跟行业趋势。'
			}
		},
		{
			path: '/AIPage',
			name: 'AIPage',
			component: () => import( /* webpackChunkName: "about" */ '@/views/AIPage.vue'),
			meta: {
				keepAlive: false,
				title: 'AI智能助手',
				description: '建数工厂AI智能问答，专为建筑行业打造，资质办理政策、招投标流程、工程费用计算标准，输入问题即得专业解答，24小时在线。'
			}
		},
		{
			path: '/CalcPage',
			name: 'CalcPage',
			component: () => import( /* webpackChunkName: "about" */ '@/views/CalcPage.vue'),
			children: generateCalcRoutes()
		},
	]
}, ]

const router = new VueRouter({
	//mode: 'hash',
	mode: 'history',
	base: process.env.BASE_URL,
	routes
})

// 默认站点信息
const DEFAULT_TITLE = '建数工厂 - 建筑企业资质|招标信息|工程计算器|一站式企业服务平台'
const DEFAULT_DESCRIPTION = '建数工厂专注建筑企业资质新办、升级、延期，税务筹划、工商注册等一站式企业服务，10年行业经验，上千家成功案例，专业团队一对一服务。'
const SITE_ORIGIN = 'https://www.jianqiyue.com'

// 移动端路径 → 对应桌面端 canonical 路径映射
const MOBILE_TO_DESKTOP_MAP = {
	'/m/home': '/',
	'/m/calc': '/CalcPage',
	'/m/bidding': '/CompanyBidding',
	'/m/bidding/detail': '/BiddingDetail',
	'/m/query': '/SelectQualification',
	'/m/query/detail': '/CompanyDetail',
	'/m/mine': '/',
	'/m/calc/CalcOne': '/CalcOne',
	'/m/calc/CalcOneSichuan': '/CalcOneSichuan',
	'/m/calc/CalcOneGd': '/CalcOneGd',
	'/m/calc/CalcOneSd': '/CalcOneSd',
	'/m/calc/CalcOneHb': '/CalcOneHb',
	'/m/calc/CalcTwo': '/CalcTwo',
	'/m/calc/CalcTwoSd': '/CalcTwoSd',
	'/m/calc/CalcTwoHb': '/CalcTwoHb',
	'/m/calc/CalcThree': '/CalcThree',
	'/m/calc/CalcThreeSichuan': '/CalcThreeSichuan',
	'/m/calc/CalcFour': '/CalcFour',
	'/m/calc/CalcFourSichuan': '/CalcFourSichuan',
	'/m/calc/CalcFive': '/CalcFive',
	'/m/calc/CalcSix': '/CalcSix',
	'/m/calc/CalcSeven': '/CalcSeven',
	'/m/calc/CalcEight': '/CalcEight',
	'/m/calc/CalcZero': '/CalcZero',
	'/m/calc/CalcZeroGdOne': '/CalcZeroGdOne',
	'/m/calc/CalcZeroGdTwo': '/CalcZeroGdTwo',
	'/m/calc/CalcZeroGdThree': '/calcZeroGdThree',
	'/m/calc/CalcZeroHb': '/calcZeroHb',
	'/m/calc/CalcShuitu': '/CalcShuitu',
	'/m/calc/CalcJiaotong': '/CalcJiaotong',
	'/m/calc/CalcJsqlx': '/CalcJsqlx',
	'/m/calc/CalcYbf': '/CalcYbf',
	'/m/calc/CalcLdaqwsps': '/CalcLdaqwsps',
	'/m/calc/CalcDzzh': '/CalcDzzh',
	'/m/calc/CalcShwd': '/CalcShwd',
	'/m/calc/CalcZcpg': '/CalcZcpg',
}

/**
 * 更新页面 canonical 标签
 * @param {string} path 当前路由 path
 * @param {object} query 当前路由 query 参数
 */
function updateCanonical(path, query) {
	let canonicalPath = path

	// 移动端页面：canonical 指向对应的桌面端页面
	if (path.startsWith('/m/') || path === '/m') {
		const basePath = path.split('?')[0]
		canonicalPath = MOBILE_TO_DESKTOP_MAP[basePath] || '/'
	}

	// 详情页带 query 参数（如 deal_id、id）需要保留参数
	let canonicalUrl = SITE_ORIGIN + canonicalPath
	const queryKeys = Object.keys(query)
	if (queryKeys.length > 0) {
		const queryStr = queryKeys.map(k => `${k}=${encodeURIComponent(query[k])}`).join('&')
		canonicalUrl += '?' + queryStr
	}

	let link = document.querySelector('link[rel="canonical"]')
	if (!link) {
		link = document.createElement('link')
		link.setAttribute('rel', 'canonical')
		document.head.appendChild(link)
	}
	link.setAttribute('href', canonicalUrl)
}

/**
 * 更新页面 meta description
 * @param {string} description 描述文本
 */
function updateMetaDescription(description) {
	let meta = document.querySelector('meta[name="description"]')
	if (!meta) {
		meta = document.createElement('meta')
		meta.setAttribute('name', 'description')
		document.head.appendChild(meta)
	}
	meta.setAttribute('content', description || DEFAULT_DESCRIPTION)
}

/**
 * 更新页面 title
 * @param {string} title 标题文本
 */
function updatePageTitle(title) {
	if (title) {
		document.title = title + ' - 建数工厂'
	} else {
		document.title = DEFAULT_TITLE
	}
}

//核心：路由切换后上报百度统计 + 更新 SEO 标题、描述和 canonical
router.afterEach((to) => {
	window._hmt.push(['_trackPageview', to.fullPath]);

	// 初始化全局 Organization JSON-LD（仅首次）
	initGlobalJsonLd();

	// 更新 canonical
	updateCanonical(to.path, to.query)

	// 更新标题和描述
	const routeMeta = to.matched[to.matched.length - 1]?.meta || {}
	if (routeMeta.dynamicTitle) {
		// 详情页等动态标题场景：保留上一次的标题，等组件加载完成后更新
		// 这里不做处理，由组件内部调用 setDynamicTitle 更新
	} else {
		updatePageTitle(routeMeta.title)
		updateMetaDescription(routeMeta.description)
	}

	// 计算器页面：注入 WebApplication + FAQPage + Breadcrumb JSON-LD
	const calcItem = CALC_REGISTRY.find(c => c.path === to.path)
	if (calcItem) {
		injectCalcJsonLd(calcItem);
	} else {
		// 非计算器页面：清理上一页的计算器 JSON-LD
		clearPageJsonLd();
	}
})

// UA 检测守卫：自动在桌面端和移动端之间跳转
router.beforeEach((to, from, next) => {
	const mobile = isMobileDevice()
	const isMobileRoute = to.path.startsWith('/m')

	// 允许手动覆盖
	if (to.query.force === 'desktop' || to.query.force === 'mobile') {
		return next()
	}

	if (mobile && !isMobileRoute) {
		return next('/m/home')
	}
	if (!mobile && isMobileRoute) {
		return next('/')
	}
	next()
})

// router.beforeEach((to, from, next) => {
//     if (to.path === '/' || to.path === '/RegisterPage') {
//         localStorage.removeItem('token');
//         next();
//     } else {
//         const token = localStorage.getItem('token');
//         if (!token && to.path !== '/') {
//             next({path: '/'})
//         } else {
//             next();
//         }
//     }
// });

export default router